"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  return {
    root: {
      // This color and opacity are fixed by design system
      color: '#343B45',
      opacity: '25%',
      height: 0,
      borderStyle: 'solid none none',
      margin: 0
    },
    fullWidth: {
      width: '100%'
    }
  };
};

var HorizontalRule = function HorizontalRule(props, ref) {
  var fullWidth = props.fullWidth,
      other = (0, _objectWithoutProperties2["default"])(props, ["fullWidth"]);
  var classes = useStyles();
  return (0, _core.jsx)("hr", (0, _extends2["default"])({
    ref: ref,
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, fullWidth && classes.fullWidth], ";label:HorizontalRule;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ib3Jpem9udGFsUnVsZS9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEJ1QiIsImZpbGUiOiIuLi8uLi9zcmMvSG9yaXpvbnRhbFJ1bGUvaW5kZXgudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIEhUTUxQcm9wcywgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGludGVyZmFjZSBIb3Jpem9udGFsUnVsZVByb3BzIGV4dGVuZHMgSFRNTFByb3BzPEhUTUxIUkVsZW1lbnQ+IHtcbiAgZnVsbFdpZHRoPzogYm9vbGVhbjtcbn1cblxuY29uc3QgdXNlU3R5bGVzID0gKCkgPT4ge1xuICByZXR1cm4ge1xuICAgIHJvb3Q6IHtcbiAgICAgIC8vIFRoaXMgY29sb3IgYW5kIG9wYWNpdHkgYXJlIGZpeGVkIGJ5IGRlc2lnbiBzeXN0ZW1cbiAgICAgIGNvbG9yOiAnIzM0M0I0NScsXG4gICAgICBvcGFjaXR5OiAnMjUlJyxcbiAgICAgIGhlaWdodDogMCxcbiAgICAgIGJvcmRlclN0eWxlOiAnc29saWQgbm9uZSBub25lJyxcbiAgICAgIG1hcmdpbjogMCxcbiAgICB9LFxuICAgIGZ1bGxXaWR0aDoge1xuICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICB9LFxuICB9IGFzIGNvbnN0O1xufTtcblxuY29uc3QgSG9yaXpvbnRhbFJ1bGU6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8SFRNTEhSRWxlbWVudCwgSG9yaXpvbnRhbFJ1bGVQcm9wcz4gPSAocHJvcHMsIHJlZikgPT4ge1xuICBjb25zdCB7IGZ1bGxXaWR0aCwgLi4ub3RoZXIgfSA9IHByb3BzO1xuICBjb25zdCBjbGFzc2VzID0gdXNlU3R5bGVzKCk7XG5cbiAgcmV0dXJuIDxociByZWY9e3JlZn0gY3NzPXtbY2xhc3Nlcy5yb290LCBmdWxsV2lkdGggJiYgY2xhc3Nlcy5mdWxsV2lkdGhdfSB7Li4ub3RoZXJ9IC8+O1xufTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihIb3Jpem9udGFsUnVsZSk7XG4iXX0= */"))
  }, other));
};

__signature__(HorizontalRule, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(HorizontalRule);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/HorizontalRule/index.tsx");
  reactHotLoader.register(HorizontalRule, "HorizontalRule", "/builds/bA1zbJom/0/gojob/ui-bits/src/HorizontalRule/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/HorizontalRule/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();